import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  /* ── Design-token CSS variables ─────────────────────────────────── */
  :root, [data-theme="dark"] {
    --clr-text-bright:    rgba(255, 255, 255, 0.85);
    --clr-text-dim:       rgba(255, 255, 255, 0.6);
    --clr-text-muted:     rgba(255, 255, 255, 0.45);
    --clr-text-faint:     rgba(255, 255, 255, 0.35);
    --clr-text-hint:      rgba(255, 255, 255, 0.18);
    --clr-accent-soft:    rgba(125, 211, 252, 0.8);
    --clr-accent-mid:     rgba(125, 211, 252, 0.5);
    --clr-accent-border:  rgba(125, 211, 252, 0.15);
    --clr-accent-border-h:rgba(125, 211, 252, 0.3);
    --clr-accent-fill:    rgba(125, 211, 252, 0.08);
    --clr-accent-fill-h:  rgba(125, 211, 252, 0.15);
    --clr-accent-subtle:  rgba(125, 211, 252, 0.1);
    --clr-hover-bg:       rgba(125, 211, 252, 0.04);
    --clr-card-bg:        rgba(15, 23, 42, 0.92);
    --clr-surface-bg:     rgba(255, 255, 255, 0.03);
    --clr-surface-border: rgba(255, 255, 255, 0.08);
    --clr-divider:        rgba(255, 255, 255, 0.1);
  }

  [data-theme="light"] {
    --clr-text-bright:    rgba(15, 23, 42, 0.9);
    --clr-text-dim:       rgba(15, 23, 42, 0.7);
    --clr-text-muted:     rgba(15, 23, 42, 0.6);
    --clr-text-faint:     rgba(15, 23, 42, 0.5);
    --clr-text-hint:      rgba(15, 23, 42, 0.18);
    --clr-accent-soft:    #0369a1;
    --clr-accent-mid:     rgba(3, 105, 161, 0.6);
    --clr-accent-border:  rgba(3, 105, 161, 0.2);
    --clr-accent-border-h:rgba(3, 105, 161, 0.4);
    --clr-accent-fill:    rgba(3, 105, 161, 0.08);
    --clr-accent-fill-h:  rgba(3, 105, 161, 0.15);
    --clr-accent-subtle:  rgba(3, 105, 161, 0.1);
    --clr-hover-bg:       rgba(3, 105, 161, 0.05);
    --clr-card-bg:        rgba(255, 255, 255, 0.95);
    --clr-surface-bg:     rgba(15, 23, 42, 0.03);
    --clr-surface-border: rgba(15, 23, 42, 0.1);
    --clr-divider:        rgba(15, 23, 42, 0.12);
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    scroll-behavior: smooth;
  }

  body {
    font-family: ${({ theme }) => theme.fonts.primary};
    background: ${({ theme }) => theme.colors.gradients.background};
    color: ${({ theme }) => theme.colors.text};
    transition: background 0.35s ease, color 0.35s ease;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    line-height: 1.6;
  }

  h1, h2, h3, h4, h5, h6 {
    line-height: 1.2;
    font-weight: 700;
  }

  a {
    color: ${({ theme }) => theme.colors.primaryDark};
    text-decoration: none;
    transition: ${({ theme }) => theme.transitions.default};

    &:hover {
      color: ${({ theme }) => theme.colors.primary};
    }
  }

  ul {
    list-style: none;
    padding-left: 0;
  }

  img {
    max-width: 100%;
    height: auto;
  }

  /* Custom scrollbar */
  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.colors.backgroundCard};
  }

  ::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colors.primary};
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: ${({ theme }) => theme.colors.primaryDark};
  }

  /* Container utility */
  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 28px;
  }

  /* Animation keyframes */
  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes slideInLeft {
    from {
      opacity: 0;
      transform: translateX(-50px);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }

  @keyframes slideInRight {
    from {
      opacity: 0;
      transform: translateX(50px);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }

  @keyframes bounce {
    0%, 20%, 50%, 80%, 100% {
      transform: translateX(-50%) translateY(0);
    }
    40% {
      transform: translateX(-50%) translateY(-10px);
    }
    60% {
      transform: translateX(-50%) translateY(-5px);
    }
  }
`;

export default GlobalStyles;